/* Signature spacer renderer. Dimensions are supplied by the fabrication contract. */
(function (root) {
  'use strict';
  function geometry(THREE, diameterMm, heightMm) {
    if (![6, 8].includes(diameterMm) || !Number.isFinite(heightMm) || heightMm <= 0) throw new Error('Dimensions intercalaire invalides');
    const radius = diameterMm / 2, half = heightMm / 2;
    const bevel = Math.min(diameterMm * 0.025, heightMm * 0.08);
    const profile = [new THREE.Vector2(0, -half), new THREE.Vector2(radius - bevel, -half)];
    for (let i = 1; i <= 4; i++) {
      const a = -Math.PI / 2 + i * Math.PI / 8;
      profile.push(new THREE.Vector2(radius - bevel + bevel * Math.cos(a), -half + bevel + bevel * Math.sin(a)));
    }
    profile.push(new THREE.Vector2(radius, half - bevel));
    for (let i = 1; i <= 4; i++) {
      const a = i * Math.PI / 8;
      profile.push(new THREE.Vector2(radius - bevel + bevel * Math.cos(a), half - bevel + bevel * Math.sin(a)));
    }
    profile.push(new THREE.Vector2(0, half));
    const result = new THREE.LatheGeometry(profile, 64);
    // Vertical UVs follow physical height, preserving the official artwork proportions.
    const position = result.attributes.position, uv = result.attributes.uv;
    for (let i = 0; i < position.count; i++) uv.setY(i, (position.getY(i) + half) / heightMm);
    uv.needsUpdate = true;
    return result;
  }
  function material(THREE, logoImage, diameterMm, heightMm) {
    const canvas = document.createElement('canvas');
    canvas.width = 2048; canvas.height = 512;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#c9ccce'; ctx.fillRect(0, 0, canvas.width, canvas.height);
    // Recolour the actual logo pixels; never substitute a font or stretch the lettering.
    const mask = document.createElement('canvas');
    mask.width = logoImage.naturalWidth; mask.height = logoImage.naturalHeight;
    const ink = mask.getContext('2d'); ink.drawImage(logoImage, 0, 0);
    const pixels = ink.getImageData(0, 0, mask.width, mask.height);
    for (let i = 0; i < pixels.data.length; i += 4) {
      const coverage = 1 - Math.min(pixels.data[i], pixels.data[i + 1], pixels.data[i + 2]) / 255;
      pixels.data[i + 3] = Math.round(pixels.data[i + 3] * coverage);
      pixels.data[i] = 28; pixels.data[i + 1] = 30; pixels.data[i + 2] = 31;
    }
    ink.putImageData(pixels, 0, 0);
    const circumference = Math.PI * diameterMm;
    const artworkHeight = Math.min(heightMm * 0.78, circumference * 0.86 * mask.height / mask.width);
    const w = artworkHeight * mask.width / mask.height / circumference * canvas.width;
    const h = artworkHeight / heightMm * canvas.height;
    ctx.drawImage(mask, (canvas.width - w) / 2, (canvas.height - h) / 2, w, h);
    const texture = new THREE.CanvasTexture(canvas);
    texture.encoding = THREE.sRGBEncoding;
    texture.anisotropy = 4;
    return new THREE.MeshPhysicalMaterial({map: texture, color: 0xffffff, metalness: 0.8, roughness: 0.32,
      clearcoat: 0.05, clearcoatRoughness: 0.4, envMapIntensity: 0.75});
  }
  const api = {geometry, material};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.ZenSignature = api;
})(typeof window !== 'undefined' ? window : globalThis);
